import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import LoginForm from './LoginForm';
import LostForm from './LostPassword';
import * as authActions from 'redux/modules/auth';
import {getWindowSize} from '../../utils/utils';
import immutable from 'immutable';
import {TextInput, RxForm, Checkbox, FormField} from 'reactis-forms';
import ReactCSSTransitionReplace from 'react-css-transition-replace';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import config from '../../config';

export default class Login extends Component {

	constructor(props) {
		super(props);
		this.state = {
			comp: 1,
			transition: 'carousel-right'
		}
	}

	showLostPassword() {
		this.setState({comp: 2, transition: 'carousel-right'});
	}

	showLogin() {
		this.setState({comp: 1, transition: 'carousel-left'});
	}

	render() {
		return (
			<div className="widget">
				<div className="panel panel-body login-form">
					<div className="text-center">
						<img src={config.assets + 'img/logo.png'} />
					</div>
						<div key={this.state.comp}>
							{this.state.comp == 1 && <LoginForm onLostPassword={() => this.showLostPassword()} />}
							{this.state.comp == 2 && <LostForm onLogin={() => this.showLogin()} />}
						</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Login/Login.js